
import ContentBox from "./ContentBox";
import React from "react";

const QuizNotFound = ({ message = "Quiz not found." }) => {
    return (
        <ContentBox className="quiz-not-found-content-box">
            <h1>{message}</h1>
        </ContentBox>
    )
};

export default QuizNotFound;